// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ViewCards(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ViewCards" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M4 20H20V13H4V20ZM4 4V11H20V4H4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ViewCards.js.map